import { CategoryType } from "@core/schema/CategoryType.js";
import { SeoFragment } from "./SeoFragment.js";

function createSeoId(webUrl: string, fragment: string): string {
	const url = new URL(webUrl);
	url.hash = fragment;
	return url.toString();
}

export function seoId(webUrl: string, fragment: SeoFragment): string {
	return createSeoId(webUrl, fragment);
}

export function returnPolicyIdForCategory(webUrl: string, category: CategoryType): string {
	const fragment =
		category === CategoryType.Coffee ? SeoFragment.ReturnPolicyPerishable : SeoFragment.ReturnPolicyStandard;
	return seoId(webUrl, fragment);
}

export function idRef(id: string): Record<"@id", string> {
	return { "@id": id };
}
